module.exports = __webpack_public_path__ + "img/food_top.f075f175.png";